
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"52","height":"52"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.372 27.35a2.643 2.643 0 00.925.925L29.5 45.588c1.819 1.069 3.311-.016 3.311-2.386V33h15.651v-.008A3.548 3.548 0 0052 29.454v-6.923A3.547 3.547 0 0048.462 19H32.808V8.8c0-2.386-1.492-3.453-3.311-2.393L1.3 23.72a2.649 2.649 0 00-.928 3.63z","fill":"#990ae3"}})])
          )
        }
      }
    